import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { PORTAL_NAME } from 'Common/consts';
const Title = ({ className }) => (_jsx("h1", Object.assign({ className: className }, { children: PORTAL_NAME }), void 0));
export default memo(Title);
